import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGlobe = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		stroke: "currentColor",
		strokeWidth: 1.5,
		fill: "none",
		strokeLinecap: "round",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				cx: 12,
				cy: 12,
				r: 8.25
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				cx: 12,
				cy: 12,
				rx: 3.9,
				ry: 8.25
			}),
			/* @__PURE__ */ _jsx("path", { d: "M3.75 12H20.25" })
		]
	})
});
export default SvgGlobe;
